var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandMoreLightTheme = function SvgExpandMoreLightTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    fillOpacity: 0.9,
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21.6L30.3 7.3l1.4 1.4L16 24.4.3 8.7l1.4-1.4"
  }))));
};
export default SvgExpandMoreLightTheme;